module.exports = __webpack_public_path__ + "static/30-dc51e6845558cea3e7c1a222fd772e3c.jpg";